/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { TextField, Divider, Grid, Paper, Snackbar } from "@material-ui/core";
import "./raw_files/styles.css";
import { injectIntl } from "react-intl";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as account from "../_redux/accountRedux";
import { getUserTravels } from "../_redux/accountCrud";
import * as moment from "moment-jalaali";
import Alert from "@material-ui/lab/Alert";
import TravelItem from "./includes/TravelItem";
import fa from "moment/locale/fa";
import { NavBar } from "./Navbar";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useState } from 'react';



export function Travels(props) {
  const [loadState, setLoadState] = React.useState(false);
  let { state } = useSelector(
    (state) => ({
      state: state.account,
    }),
    shallowEqual
  );
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [ticketNumber, setTicketNumber] = useState(null)



  const searchState=useSelector((state) => state.search);

  const handleChange = (e) => {
    setTicketNumber(e.target.value)
  }



  moment.locale("fa", fa);
  moment.loadPersian();
  React.useEffect(() => {
    props.set_loading(true);
        
        const userCookies = JSON.parse(window.localStorage.getItem("userInformation"))
    getUserTravels(userCookies).then((res) => {
      
      props.getUserTravels(res.data);
      props.set_loading(false);
      setLoadState(true);
    });
  }, [])

  const callTravels = () => {

    let d1 = fromDate.year + "/" + fromDate.month + "/" + fromDate.day;

    moment.locale("en");

    d1 = moment(d1, 'jYYYY/jM/jD').format('YYYY-MM-DD')

    let d2 = toDate.year + "/" + toDate.month + "/" + toDate.day;

    moment.locale("en");

    d2 = moment(d2, 'jYYYY/jM/jD').format('YYYY-MM-DD')

    const data = {
      from: d1,
      to: d2,
      ticketId: ticketNumber
    }
    if (fromDate == null) delete data.from
    if (toDate == null) delete data.to
    if (ticketNumber == null) delete data.ticketId
    props.set_loading(true);
    const userCookies = JSON.parse(window.localStorage.getItem("userInformation"))
    getUserTravels(userCookies, data).then((res) => {
      props.getUserTravels(res.data);
      props.set_loading(false);
      setLoadState(true);
    });
  }



  return (
    <>
      <Snackbar
        open={state.snackOpen}
        autoHideDuration={8000}
        onClose={() => props.hideMessage()}
      >
        <Alert onClose={() => props.hideMessage()} severity={state.snackType}>
          {state.snackMessage}
        </Alert>
      </Snackbar>
      <Grid container spacing={3}>
        <Grid item sm={12} className={"mt-5"}>
          <NavBar className="gutter-b" />
        </Grid>
        {loadState ? (
          <Grid item sm={12} className={"mt-5"}>
            <Grid container spacing={3}>
              <Grid item sm={12} className={"mt-5"}>
                <Paper elevation={3} style={{ padding: 20, marginBottom: 35 }}>
                  <h2>لیست سفر های شما</h2>
                  <Divider style={{ marginBottom: 20 }} />
                  {/* <h5>تاریخچه مسافرت های شما</h5> */}
                  <div className="row">
                    <div className="col bg-light-primary px-6 py-8 rounded-xl mr-7 mb-7">
                      <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                        <SVG
                          src={toAbsoluteUrl("/media/svg/icons/Home/Clock.svg")}
                        ></SVG>
                      </span>
                      <span className="font-weight-bold font-size-h6">
                        <b>{state.travels.hourCount}</b> ساعت با ایباس
                      </span>
                    </div>
                    <div className="col bg-light-primary px-6 py-8 rounded-xl mr-7 mb-7">
                      <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Media/Equalizer.svg"
                          )}
                        ></SVG>
                      </span>
                      <span className="font-weight-bold font-size-h6">
                        <b>{state.travels.distanceCount}</b> کیلومتر با ایباس
                      </span>
                    </div>
                    <div className="col bg-light-primary px-6 py-8 rounded-xl mr-7 mb-7">
                      <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Shopping/Ticket.svg"
                          )}
                        ></SVG>
                      </span>
                      <span className="font-weight-bold font-size-h6">
                        <b>{state.travels.travelCount}</b> سفر با ایباس
                      </span>
                    </div>
                  </div>
                </Paper>
              </Grid>
              <div className={"col-sm-12 col-xs-12 p-5 card card-custom"} style={{ display: "flex", flexDirection: "row" }}>
                <div className={'col-sm-2 col-xs-12 p-2 ml-2 mr-2'}>
                  <div className='search-dat-picker-holder'>
                  {/* <DatePicker
                    className="DatePickerr"
                    variant="outlined"
                    value={fromDate}
                    inputPlaceholder="از تاریخ"
                      value={selectedDay}
                    onChange={(value) => {
                      setFromDate(value)
                    }}
                    shouldHighlightWeekends
                    locale="fa"
                  /> */}
                  </div>
                </div>
                <div className={'col-sm-2 col-xs-12 p-2 mr-2 ml-2  '}>
                  <div className='search-dat-picker-holder'>
                    {/* <DatePicker
                      className="DatePickerr"
                      variant="outlined"
                      value={toDate}
                      inputPlaceholder="تا تاریخ"
                       value={selectedDay}
                      // minimumDate={utils('fa').getToday()}
                      onChange={(value) => {
                        setToDate(value)
                      }}
                      shouldHighlightWeekends
                      locale="fa"
                    /> */}
                  </div>
                </div>
                <div className={'col-sm-2 col-xs-12 p-2 mr-2 ml-2 '}>
                  <TextField
                    label={<span>شماره بلیط</span>}
                    variant="outlined"
                    onChange={handleChange}
                  />
                </div>
                <div className={'col-xs-12 col-sm-2 text-right p-2 mr-5 ml-5'}>
                  <button className={"btn btn-danger font-weight-bold py-3 px-6 h-100 w-100 "}
                    onClick={callTravels}
                  >
                    جستجو
                  </button>
                </div>
              </div>

              {state.travels.length === 0
                ? null
                : state.travels.travelReports.map((x, key) => (
                  <Grid item sm={12} key={key}>
                    <TravelItem data={x} />
                  </Grid>
                ))}
            </Grid>
          </Grid>
        ) : <Grid
          item
          xs={12}
          className={"mt-4"}
          style={{ height: "4rem", paddingBlock: "15px", backgroundColor: 'white' }}
        >
          <b>null</b>
        </Grid>}
      </Grid>
    </>
  );
}

export default injectIntl(connect(null, account.actions)(Travels));
